module.exports = __webpack_public_path__ + "img/Dominik Teiml.12649f93.jpg";